var map = {
	"./photo.png": 75104,
	"./photo1.png": 63362,
	"./photo2.png": 90331,
	"./photo3.png": 87829,
	"./photo4.png": 70891,
	"./photo5.png": 22206,
	"./photo6.png": 9887,
	"./photo7.png": 24454,
	"./photo8.png": 32190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22302;